import "../admin-dashboard.css";
import "./generate-token.css";
import DataTable from "datatables.net-react";
import DT from "datatables.net-bs5";
import { useGenerateTokenHook } from "./useGenerateTokenHook";
DataTable.use(DT);

const GenerateToken = () => {
  const {
    tokens,
    setSearchTerm,
    recordCount,
    setRecordCount,
    isLoading,
    handleSubmit,
    filterHandler,
    count,
    setCount,
  } = useGenerateTokenHook();

  return (
    <>
      <section className="bg-body p-5 m-2 shadow-lg rounded">
        <h2 className="mb-4 green">
          GENERATE TOKENS AGAINST YOUR MEMBERSHIP ID
        </h2>
        <div className="ms-4">
          <div className="mb-2">
            <label className="me-3 green fs-5 fw-normal">
              ENTER NUMBER OF TOKENS
            </label>
            <input
              type="number"
              value={count}
              onChange={(e) => setCount(e.target.value)}
              placeholder="ENTER # OF TOKENS"
              className="token-input"
            />
          </div>
          <button
            disabled={count == 0 || isLoading}
            onClick={handleSubmit}
            className="btn btn-success btn-lg"
          >
            {isLoading ? (
              <i className="fas fa-spinner fa-spin"></i>
            ) : (
              "GENERATE TOKENS"
            )}
          </button>
        </div>
      </section>
      {tokens.length > 0 && (
        <section className="card">
          <div className="card-header">
            <h3 className="token-text">
              You can view generated tokens in the Valid Tokens section later
            </h3>
          </div>
          <div className="card-body">
            <div className="d-flex justify-content-between align-items-center mb-3">
              <div>
                <label htmlFor="entries" className="form-label me-2 fw-bolder">
                  Show
                </label>
                <select
                  id="entries"
                  onChange={(e) => setRecordCount(e.target.value)}
                  className="form-select d-inline-block w-auto"
                >
                  <option value="25">25</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                </select>
                <span className="ms-2 fw-bolder">entries</span>
              </div>
              <div>
                <label htmlFor="search" className="form-label me-2 fw-bolder">
                  Search:
                </label>
                <input
                  id="search"
                  onChange={(e) => setSearchTerm(e.target.value)}
                  type="text"
                  className="form-control d-inline-block w-auto"
                />
              </div>
            </div>
            <div className="table-responsive">
              <table className="table table-bordered custom-table">
                <thead>
                  <tr>
                    <th>No.</th>
                    <th>Token Generated Date</th>
                    <th>Status</th>
                    <th>Generated Token</th>
                    <th>Fee</th>
                  </tr>
                </thead>
                <tbody>
                  {tokens
                    .filter(filterHandler)
                    .slice(0, recordCount)
                    .map((token) => (
                      <tr key={token.id}>
                        <td>{token.id}</td>
                        <td>{token.date || "—"}</td>
                        <td className="text-success fw-bold">ACTIVE</td>
                        <td>{token.token}</td>
                        <td>{token.fee}</td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          </div>
        </section>
      )}
    </>
  );
};

export default GenerateToken;
